import { AxiosAdapter } from '../commons/adapters';
import { IServicesIaPlansBackendRequestDto } from '../pages/manager/servicios-ia/comercial/planes/interfaces/IServicesIaPlansBackend';
import { QueryPagination } from 'commons/interfaces';
import { buildQuery } from 'commons/utils/helpers';

const endPoint = '/v1/services-ia-plans';
const Http = new AxiosAdapter();

export const getAllServicesIaPlansService = async (query?: QueryPagination) => {
  try {
    return await Http.get<any>(`${endPoint}?${buildQuery(query)}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('getAllServicesIaPlansService error', error);
  }
};

export const getServicesIaPlansFormService = async () => {
  try {
    return await Http.get<any>(`${endPoint}/form`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('getServicesIaPlansFormService error', error);
  }
};

export const getServicesIaPlanByIdService = async (id: string) => {
  try {
    return await Http.get<any>(`${endPoint}/${id}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('getServicesIaPlanByIdService error', error);
  }
};

export const saveServicesIaPlanService = async (data: IServicesIaPlansBackendRequestDto) => {
  try {
    return await Http.post<any>(`${endPoint}`, data);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('saveServicesIaPlanService error', error);
  }
};

export const editServicesIaPlanService = async (
  id: string,
  data: IServicesIaPlansBackendRequestDto
) => {
  try {
    return await Http.put<any>(`${endPoint}/${id}`, data);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('editServicesIaPlanService error', error);
  }
};

export const deleteServicesIaPlanService = async (id: string, query?: QueryPagination) => {
  try {
    return await Http.deleteTable<any>(`${endPoint}/${id}?${buildQuery(query)}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('deleteServicesIaPlanService error', error);
  }
};

export const restoreServicesIaPlanService = async (id: string, query?: QueryPagination) => {
  try {
    return await Http.patchTable<any>(`${endPoint}/${id}/restore?${buildQuery(query)}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('restoreServicesIaPlanService error', error);
  }
};
